import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms"; 
import { ViewEncapsulation } from '@angular/core'; 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';
import { SendCodeModel } from '@shared/security/send-code.model';
import { AppConsts } from '@shared/app-consts';
import { ValidTwoFactorProviders } from '@shared/security/valid-twofactor-providers';


@Component({
  selector: 'app-twofactor-sendcode',
  templateUrl: './send-code.component.html',
  styleUrls: ['./send-code.component.scss'] 
})
export class TwoFactorSendCodeComponent implements OnInit  {
    selectedProvider:ValidTwoFactorProviders;
    providers:ValidTwoFactorProviders[]=[];
    sendCodeForm:FormGroup;     
    email:string;
    infoMessage:string;  
    get f() { return this.sendCodeForm.controls; }
    
    constructor(private service: AuthenticationService,
        private router: Router,
        public formBuilder: FormBuilder, 
        private changeDedectionRef :ChangeDetectorRef,
        private loaderService: LoaderService, private renderer: Renderer2,
        @Inject(DOCUMENT) private _document,   private zone: NgZone) {
        }

        
  ngOnInit() {
      this.buildForm();
      this.initialize();
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }

  initialize(){
      this.email= sessionStorage.getItem(AppConsts.DecisielCurrentEmail);

      if(!this.email || this.email == null || this.email.trim() === '')
       this.router.navigate(['login']);

      this.loaderService.showLoader();      
      this.service.getValidTwoFactorProviders(this.email).subscribe((response:any)=>{ 
        if(response && response !=null && response.length > 0)
        {
          this.providers = response; 
          this.sendCodeForm.controls['factor'].setValue(response[0].Name);
        }
        else
        this.router.navigate(['login']);

        this.loaderService.hideLoader();
      },(error)=>{
          this.loaderService.hideLoader();
      });
  }

 buildForm(){
    this.sendCodeForm = this.formBuilder.group({ 
        factor: ["", Validators.required]
    });
    
    this.sendCodeForm.controls['factor'].valueChanges.subscribe((value) => { 
      if(value && value != null)
      {
        const _selectedProvider = this.providers.filter(function (e) {
          return e.Name === value;
        });
          this.selectedProvider = _selectedProvider[0] as ValidTwoFactorProviders;
          if(value === "Phone")
          this.infoMessage = "Un code de sécurité va être envoyé sur votre numéro mobile "+ this.selectedProvider.ProviderValue;
          if(value === "Email")
          this.infoMessage = "Un code de sécurité va être envoyé sur votre adresse email "+ this.selectedProvider.ProviderValue;
      }
        });   
 }

 sendCode(){
     if(this.sendCodeForm.invalid)
     return; 
  let model = new SendCodeModel();
  model.SelectedProvider = this.selectedProvider.Name;
  model.Email = sessionStorage.getItem(AppConsts.DecisielCurrentEmail);
  this.loaderService.showLoader();
  this.service.sendCodeTwofactor(model).subscribe((response : any)=>{
    this.loaderService.hideLoader();
   if(response){
       sessionStorage.setItem(AppConsts.DecisielCurrentTwoFactorProvider,this.selectedProvider.Name); 
     this.zone.runOutsideAngular(() => {
      window.location.href = '/login/verify-code';
    });
   }
  },(error)=>{
     this.loaderService.hideLoader();
  });

 }
}